const isNumberHighlighted = (number) => {
  return guessedNumber === number;
};
import React, { useState, useEffect } from "react";

const BinaryMindReader = () => {
  const [selectedCards, setSelectedCards] = useState(new Set());
  const [guessedNumber, setGuessedNumber] = useState(null);
  const [isRevealing, setIsRevealing] = useState(false);
  const [showMagicEffect, setShowMagicEffect] = useState(false);

  // 定义6张卡片的数据
  const cards = [
    {
      id: 1,
      title: "卡片 1",
      value: 1,
      numbers: [
        [1, 9, 17, 25, 33, 41, 49, 57],
        [3, 11, 19, 27, 35, 43, 51, 59],
        [5, 13, 21, 29, 37, 45, 53, 61],
        [7, 15, 23, 31, 39, 47, 55, 63],
      ],
    },
    {
      id: 2,
      title: "卡片 2",
      value: 2,
      numbers: [
        [2, 10, 18, 26, 34, 42, 50, 58],
        [3, 11, 19, 27, 35, 43, 51, 59],
        [6, 14, 22, 30, 38, 46, 54, 62],
        [7, 15, 23, 31, 39, 47, 55, 63],
      ],
    },
    {
      id: 3,
      title: "卡片 3",
      value: 4,
      numbers: [
        [4, 12, 20, 28, 36, 44, 52, 60],
        [5, 13, 21, 29, 37, 45, 53, 61],
        [6, 14, 22, 30, 38, 46, 54, 62],
        [7, 15, 23, 31, 39, 47, 55, 63],
      ],
    },
    {
      id: 4,
      title: "卡片 4",
      value: 8,
      numbers: [
        [8, 12, 24, 28, 40, 44, 56, 60],
        [9, 13, 25, 29, 41, 45, 57, 61],
        [10, 14, 26, 30, 42, 46, 58, 62],
        [11, 15, 27, 31, 43, 47, 59, 63],
      ],
    },
    {
      id: 5,
      title: "卡片 5",
      value: 16,
      numbers: [
        [16, 20, 24, 28, 48, 52, 56, 60],
        [17, 21, 25, 29, 49, 53, 57, 61],
        [18, 22, 26, 30, 50, 54, 58, 62],
        [19, 23, 27, 31, 51, 55, 59, 63],
      ],
    },
    {
      id: 6,
      title: "卡片 6",
      value: 32,
      numbers: [
        [32, 36, 40, 44, 48, 52, 56, 60],
        [33, 37, 41, 45, 49, 53, 57, 61],
        [34, 38, 42, 46, 50, 54, 58, 62],
        [35, 39, 43, 47, 51, 55, 59, 63],
      ],
    },
  ];

  const handleCardSelect = (cardId) => {
    const newSelected = new Set(selectedCards);
    if (newSelected.has(cardId)) {
      newSelected.delete(cardId);
    } else {
      newSelected.add(cardId);
    }
    setSelectedCards(newSelected);
    setGuessedNumber(null); // 重置猜测结果
  };

  const performMagic = () => {
    setShowMagicEffect(true);
    setIsRevealing(true);

    // 计算猜测的数字
    let sum = 0;
    selectedCards.forEach((cardId) => {
      const card = cards.find((c) => c.id === cardId);
      if (card) sum += card.value;
    });

    // 延迟显示结果，增加神秘感
    setTimeout(() => {
      setGuessedNumber(sum);
      setIsRevealing(false);

      // 稍微延迟后滚动到页面底部，确保结果区域可见
      setTimeout(() => {
        window.scrollTo({
          top: document.documentElement.scrollHeight,
          behavior: "smooth",
        });
      }, 100);
    }, 2000);

    // 3秒后关闭魔法效果
    setTimeout(() => {
      setShowMagicEffect(false);
    }, 3000);
  };

  const isNumberHighlighted = (number) => {
    return guessedNumber === number;
  };

  const resetGame = () => {
    setSelectedCards(new Set());
    setGuessedNumber(null);
    setIsRevealing(false);
    setShowMagicEffect(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white relative overflow-hidden">
      {/* 魔法粒子效果背景 */}
      {showMagicEffect && (
        <div className="fixed inset-0 pointer-events-none z-10">
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className="absolute w-2 h-2 bg-yellow-400 rounded-full animate-ping"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 2}s`,
                animationDuration: `${1 + Math.random() * 2}s`,
              }}
            />
          ))}
        </div>
      )}

      {/* 头部 */}
      <div className="relative z-20">
        <header className="text-center py-8 px-4">
          <h1 className="text-5xl font-bold mb-4 bg-gradient-to-r from-yellow-400 to-orange-500 bg-clip-text text-transparent">
            🔮 二进制读心术 🔮
          </h1>
          <p className="text-xl text-blue-200 max-w-2xl mx-auto">
            想一个 1～63 的数字，勾选包含它的卡片，我将读出你心中所想！
          </p>
        </header>

        {/* 卡片区域 */}
        <div className="flex justify-center px-4 mb-8">
          <div className="flex flex-wrap justify-center gap-6 max-w-none">
            {cards.map((card) => (
              <div
                key={card.id}
                className={`bg-white/10 backdrop-blur-lg rounded-xl p-6 transition-all duration-300 cursor-pointer transform hover:scale-105 hover:bg-white/20 w-80 ${
                  selectedCards.has(card.id)
                    ? "ring-4 ring-yellow-400 bg-white/20 shadow-2xl shadow-yellow-400/50"
                    : "shadow-xl"
                }`}
                onClick={() => handleCardSelect(card.id)}
              >
                <h3 className="text-xl font-bold text-center mb-4 text-yellow-300">
                  {card.title}
                </h3>

                <div className="bg-white/20 rounded-lg p-4 mb-4">
                  <table className="w-full table-fixed">
                    <tbody>
                      {card.numbers.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                          {row.map((number, colIndex) => (
                            <td
                              key={colIndex}
                              className="p-1 text-center text-sm font-medium text-white hover:bg-white/20 rounded transition-all duration-300"
                              style={{ width: "12.5%" }}
                            >
                              {number}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="text-center">
                  <div
                    className={`inline-flex items-center space-x-2 transition-all duration-300 ${
                      selectedCards.has(card.id)
                        ? "text-yellow-300"
                        : "text-blue-200"
                    }`}
                  >
                    <input
                      type="checkbox"
                      checked={selectedCards.has(card.id)}
                      onChange={() => handleCardSelect(card.id)}
                      className="w-5 h-5 text-yellow-400 rounded focus:ring-yellow-400 focus:ring-2"
                    />
                    <span className="font-medium">在这里看到你的数字？</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 控制按钮 */}
        <div className="text-center mb-8">
          <button
            onClick={performMagic}
            disabled={selectedCards.size === 0 || isRevealing}
            className={`px-8 py-4 text-xl font-bold rounded-full transition-all duration-300 transform ${
              selectedCards.size === 0 || isRevealing
                ? "bg-gray-600 text-gray-400 cursor-not-allowed"
                : "bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 hover:scale-105 shadow-2xl hover:shadow-purple-500/50"
            } mr-4`}
          >
            {isRevealing ? (
              <div className="flex items-center space-x-2">
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                <span>读心中...</span>
              </div>
            ) : (
              "🎭 施展读心术"
            )}
          </button>

          <button
            onClick={resetGame}
            className="px-6 py-3 text-lg font-medium bg-gray-700 hover:bg-gray-600 rounded-full transition-all duration-300 transform hover:scale-105"
          >
            重新开始
          </button>
        </div>

        {/* 结果显示 */}
        <div className="max-w-2xl mx-auto px-4">
          {guessedNumber !== null && (
            <div className="bg-gradient-to-r from-yellow-500/20 to-orange-500/20 backdrop-blur-lg rounded-2xl p-8 text-center shadow-2xl border border-yellow-400/30 animate-fade-in">
              {guessedNumber > 0 && guessedNumber <= 63 ? (
                <div>
                  <div className="text-6xl mb-4 animate-bounce">🎭</div>
                  <h2 className="text-3xl font-bold mb-6 text-yellow-300">
                    我读到了你的心思！
                  </h2>
                  <div className="text-7xl font-bold mb-4 bg-gradient-to-r from-yellow-400 to-orange-500 bg-clip-text text-transparent animate-pulse">
                    {guessedNumber}
                  </div>
                  <p className="text-xl text-blue-200">
                    这就是你心中所想的数字！
                  </p>
                </div>
              ) : guessedNumber === 0 ? (
                <div>
                  <div className="text-6xl mb-4">🤔</div>
                  <p className="text-xl text-blue-200">
                    你没有选择任何卡片，也许你想的数字是 0 或超出范围？
                  </p>
                </div>
              ) : (
                <div>
                  <div className="text-6xl mb-4">❓</div>
                  <p className="text-xl text-blue-200">
                    似乎超出了 1-63 的范围，请重新选择！
                  </p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in {
          animation: fade-in 0.6s ease-out;
        }
      `}</style>
      <footer className="mt-8 w-full text-center text-sm text-gray-500">
        © {new Date().getFullYear()} 孙维刚教育研究院-陈硕老师 保留所有权利。
      </footer>
    </div>
  );
};

export default BinaryMindReader;
